var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "box" },
    [
      _c("h1", { staticClass: "subtitle is-5" }, [_vm._v("Aspectos globales")]),
      _vm._v(" "),
      _c("h1", { staticClass: "title is-1" }, [_vm._v("Editar")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm.fetching
        ? _c("div", { staticClass: "notification" }, [
            _c("i", { staticClass: "fas fa-sync fa-spin" }),
            _vm._v("Cargando aspecto...\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.ready
        ? _c("aspectos-form", {
            attrs: { edit: true, previousData: _vm.aspecto },
            on: { submit: _vm.submit },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }